module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-mobile-en.12fe46c1.webp";